import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs/ReplaySubject';

import { config } from '../../../config';

@Injectable()
export class GoogleMapsService {
  api: ReplaySubject<typeof google.maps> = new ReplaySubject();

  constructor() {
    const script = document.createElement('script');
    script.async = true;
    script.onload = () => this.api.next(google.maps);
    script.src = `https://maps.google.com/maps/api/js?key=${config.googleMapsApiKey}&libraries=places`;
    document.body.appendChild(script);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/google-maps.service.ts